import { Location } from '@cobliteam/common-types';

/**
 * Preferência do cliente entre o mapa clássico (`/monitoring`, v1) e o Monitoramento V2 (`/monitoring-v2`).
 * Os links do painel continuam apontando para `/monitoring`: é o gate dessa rota que lê a preferência e
 * manda para a V2, como o `/tracking` faz com o replay.
 */
export type MonitoringVersion = 'v1' | 'v2';

/** Gravada pelo `useLocalStorage`, então em JSON (`"v2"`), não a string crua. */
export const MONITORING_VERSION_STORAGE_KEY = 'monitoring-version';

/** Leitura fora do React (preload da rota); o gate e a troca usam o `useLocalStorage`. */
export const readMonitoringVersion = (): MonitoringVersion | undefined => {
  try {
    const value = JSON.parse(window.localStorage.getItem(MONITORING_VERSION_STORAGE_KEY) ?? 'null');
    return value === 'v1' || value === 'v2' ? value : undefined;
  } catch {
    return undefined;
  }
};

/** Deep link que abre a outra versão já focando o veículo, no formato que as duas entendem. */
export const monitoringPathFor = (version: MonitoringVersion, licensePlate?: string) => {
  const pathname = version === 'v2' ? Location.MONITORING_V2 : Location.MONITORING;
  return licensePlate ? `${pathname}?search=${encodeURIComponent(licensePlate)}&focus=true` : pathname;
};
